import { Modal, Table, Button, message } from "antd";
import { PaperClipOutlined, DeleteOutlined } from "@ant-design/icons";
import { useState } from "react";
import RemarksComponent from "./RemarksComponent";
import { getInvoiceDownload } from "../../redux/PayoutPartnerInvoiceUpload/Action";
import { connect } from "react-redux";
import { Payout_Service } from "../../redux/Url";
import moment from "moment";

const AddInvoice = (props) => {
    const [remarks, setRemarks] = useState(false);
    const [isHistory, setIsHistory] = useState(false)
    const {
        isModalOpen,
        setIsModalOpen,
        invoiceData,
        setInvoiceData,
        resData,
    } = props;

    const handleCancel = () => {
        setIsModalOpen(false);
    }
    const handleRemarksModal = () => {
        setRemarks(true);
        setIsHistory(true);
    }

    const handleInvoicePath = async (data) => {
        try {
            // const response = await props.getInvoiceDownloadAction({
            //   accessToken: props.accessToken,
            //   filePath: data.invoicePath,
            // });

            const response = await fetch(
                `${Payout_Service}/reports/download/partnerDoc?path=${data.invoicePath}`,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Authorization': `Bearer ${props.accessToken}`,
                        // Add other headers if needed
                    },
                }
            );

            if (!response.ok) {
                console.error('No PDF data received.');
                return;
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = data.fileName || 'downloaded-file.pdf'; // Set desired filename
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);

            message.success('Download successful!');
        } catch (error) {
            message.error('Download failed. Please try again.');
            console.error('Download failed:', error);
        }

    };




 function getFileTypeFromPath(path) {
  if (!path) return '';
  const lastDot = path.lastIndexOf('.');
  if (lastDot === -1) return '';
  return path.substring(lastDot + 1).toLowerCase();
}

  const handlePayoutPath = async (data) => {
  try {
    // const response = await props.getInvoiceDownloadAction({
    //   accessToken: props.accessToken,
    //   filePath: data.invoicePath,
    // });

     const response = await fetch(
      `${Payout_Service}/reports/download/partnerDoc?path=${data.payoutPath}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Authorization': `Bearer ${props.accessToken}`,
          // Add other headers if needed
        },
      }
    );

    if (!response.ok) {
      console.error('No PDF data received.');
      return;
    }

   const getFileExtension = (getFileTypeFromPath(data.payoutPath) || 'pdf');
    console.log("file type", getFileExtension);


  
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = data.fileName || `downloaded-file.${getFileExtension}`; // Set desired filename
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

    message.success('Download successful!');
  } catch (error) {
    message.error('Download failed. Please try again.');
    console.error('Download failed:', error);
  }
  // await downloadPdf(data);
};

    const handleDelete = (record) => {
    }

    const columnsData = [
        {
            title: "Invoice Number", dataIndex: "invoiceId", key: "invoiceId", align: 'center',
            render: (record) => {
                const invoiceNumber = record.split('_')[0] || ''
                return (
                    <span>{invoiceNumber}</span>
                )
            }
        },
        { title: "Invoice Date", dataIndex: "invoiceDate", key: "invoiceDate", align: 'center', render: (date) => date ? moment(date).format("MMMM D, YYYY") : "-" },
        {
            title: "Invoice Report", dataIndex: "invoicePath", key: "invoicePath", align: 'center',
            render: (_, partner) => {
                const fullFileName = partner.invoicePath?.split('/').pop() || '';
                const lastUnderscore = fullFileName.lastIndexOf('_');
                const fileName =
                    lastUnderscore !== -1
                        ? fullFileName.substring(0, lastUnderscore) + fullFileName.substring(fullFileName.lastIndexOf('.'))
                        : fullFileName;
                return (
                    <a type="link" style={{ color: "#1b8593", textDecoration: 'none', cursor: 'pointer' }} >
                        <Button className="invoicePaperClip" onClick={() =>
                            handleInvoicePath(partner)
                        }>
                            {/* <PaperClipOutlined /> */}<span style={{ color: "#1b8593", }}><u>{fileName}</u></span>
                        </Button>
                    </a>
                )
            }
        },
        {
            title: "Payout Report", dataIndex: "payoutPath", key: "payoutPath", align: 'center',
            render: (_, partner) => {
                const fullFileName = partner.payoutPath?.split('/').pop() || '';
                const lastUnderscore = fullFileName.lastIndexOf('_');
                const fileName =
                    lastUnderscore !== -1
                        ? fullFileName.substring(0, lastUnderscore) + fullFileName.substring(fullFileName.lastIndexOf('.'))
                        : fullFileName;

                return (
                    <a type="link" style={{ color: "#1b8593", textDecoration: 'none', cursor: 'pointer' }} >
                        <Button className="invoicePaperClip" onClick={() => handlePayoutPath(partner)}>
                            {/* <PaperClipOutlined /> */}
                            <span style={{ color: "#1b8593", }}><u>{fileName}</u></span>
                        </Button>
                    </a>
                )
            }
        },
        {
            title: "Remark", dataIndex: "Remark", key: "Remark", align: 'center',
            render: (_, record) => (
                <span style={{ fontSize: "14px", maxWidth: "200px", display: "inline-block"  }}>{record?.remarks?.remarksComment}</span>
            )
        },
        // {title:"Action", dataIndex:"Action", key:"Action",
        //     render:(_,record)=>(
        //         <Button className="deleteRecord" onClick={() => handleDelete(record)}><DeleteOutlined/></Button>
        //     )
        // },
    ]


    return (
        <>
            <Modal open={isModalOpen} width={800} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleCancel}>
                <Table dataSource={invoiceData} style={{ marginTop: "20px", maxHeight: "60vh", overflow: "auto" }} columns={columnsData} pagination={false} scroll={{ x: "max-content" }} />

            </Modal>
            <RemarksComponent
                resData={resData}
                remarks={remarks}
                setRemarks={setRemarks}
                isHistory={isHistory}
                setIsHistory={setIsHistory}

            />
        </>
    )

}

const mapDispatchToProps = (dispatch) => {
    return {
        getInvoiceDownloadAction: (data) => dispatch(getInvoiceDownload(data)),
    };
};

const mapStateToProps = (state) => {
    return {
        accessToken: state && state.auth && state.auth.idToken,
        // resData: state.payoutReducer.resData,
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(AddInvoice);